import { render, staticRenderFns } from "./AppTweetit.vue?vue&type=template&id=032bc350&"
import script from "./AppTweetit.vue?vue&type=script&lang=js&"
export * from "./AppTweetit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports